module.exports = __webpack_public_path__ + "static/media/disclusion.63070d3b.svg";